import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { azureThrottleEnabled, azureStoreFullMessage } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "azureThrottleEnabled", defaultChecked: azureThrottleEnabled == null ? void 0 : azureThrottleEnabled.value, onChange }),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "azureStoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: azureStoreFullMessage == null ? void 0 : azureStoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("azure.fields.store_full_message_help")
      }
    )
  );
};
export default FormAdvancedOptions;
